import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=c190a8c4&"
import script from "./RightSideBar.vue?vue&type=script&lang=ts&"
export * from "./RightSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports